const $       = require('jquery');
const evtbus  = require('../evtbus');
const eventer = require('../util/eventer');
const Tabs    = require('../ctrl/tabs');

const api   = eventer({});
const tabs  = Tabs();
const elem  = $(`<div class="desktop-nav wrfont"></div>`);

const TAB_ORDER = {
  notes: 10,
  thumb_view: 20,
  supplements: 30,
  figures: 40,
  cited_by: 50,
  metrics: 60,
  related: 70,
  references: 80,
  supplement_info: 90,
  export: 100
};

let activeId = '';

$(init);

function init() {
  elem.appendTo('body');
  tabs.init(elem);
  setTabbable(false);
}

function add(opts) {
  tabs.add(Object.assign(opts, { index: TAB_ORDER[opts.id] }));
  setTabbable(isOpen());
}

function remove(id) {
  tabs.remove(id);
}

function update() {}

function addUserCtl(userCtl) {
  elem.prepend(userCtl);
}

function open(tabId) {
  if (!tabId && !tabs.activeId) {
    tabId = (tabs.sorted()[0] || {}).id;
  }
  if (tabId) {  
    tabs.select(tabId);
    elem.parent().addClass(tabId);
    elem.parent().removeClass(activeId);
    activeId = tabId;
  }
  elem.parent().addClass('desktop-nav-open');
  setTabbable(true);
  api.trigger('opened', [activeId]);
}

function isOpen() {
  return elem.parent().hasClass('desktop-nav-open');
}

function setTabbable(enabled) {
  elem.find('button, input, [contenteditable]')
    .attr('tabindex', enabled ? 0 : -1);
}

function close() {
  if (!isOpen()) return;
  elem.parent().removeClass(`desktop-nav-open ${tabs.activeId}`);
  setTabbable(false);
  api.trigger('closed');
}

function toggle(id) {
  isOpen() ? close() : open(id);
}

api.add = add;
api.remove = remove;
api.update = update;
api.open = open;
api.close = close;
api.toggle = toggle;
api.addUserCtl = addUserCtl;

Object.defineProperty(api, 'isOpen', {
  get() { return isOpen(); }
});
Object.defineProperty(api, 'activeId', {
  get() { return tabs.activeId; }
});

module.exports = api;
